export default {
  path: 'settings/tags',
  name: 'RoadMaintenanceTags',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TagsIndex.vue')
}
